import { render, staticRenderFns } from "./LandingSubtitle.vue?vue&type=template&id=b1476fc8&scoped=true"
import script from "./LandingSubtitle.vue?vue&type=script&lang=js"
export * from "./LandingSubtitle.vue?vue&type=script&lang=js"
import style0 from "./LandingSubtitle.vue?vue&type=style&index=0&id=b1476fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1476fc8",
  null
  
)

export default component.exports